import messaging from '@react-native-firebase/messaging';
import {Notifier, NotifierComponents} from 'react-native-notifier';
import {PERMISSIONS, request} from 'react-native-permissions';
import {Platform} from 'react-native';
import {SCREENS} from '~constants';
import {navigationRef} from '~containers/Core/navigation/Navigation';
// Conditionally import OneSignal for native platforms only
import * as oneSignalStub from '~services/web/oneSignalStub';
let OneSignal: any = null;
if (Platform.OS !== 'web') {
  OneSignal = require('react-native-onesignal').default;
} else {
  OneSignal = oneSignalStub.OneSignal;
}

export const getFcmToken = async () => {
  let token = null;
  try {
    // Skip FCM token retrieval on web platform
    if (Platform.OS === 'web') {
      console.log('🌐 [WEB] Skipping FCM token retrieval on web platform');
      return null;
    }

    console.log('🔔 Starting FCM token retrieval...');
    await checkApplicationNotificationPermission();
    await registerAppWithFCM();

    // Add timeout to prevent hanging on physical devices
    const tokenPromise = messaging().getToken();
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('FCM token timeout')), 10000)
    );

    token = await Promise.race([tokenPromise, timeoutPromise]);
    console.log('✅ FCM token retrieved successfully');
  } catch (error) {
    console.error('❌ getFcmToken Device Token error:', error);
  }
  return token;
};

export const checkApplicationNotificationPermission = async () => {
  try {
    // Skip notification permission check on web platform
    if (Platform.OS === 'web') {
      console.log('🌐 [WEB] Skipping notification permission check on web platform');
      return false;
    }

    console.log('🔔 Checking notification permissions...');
    if (Platform.OS === 'ios') {
      const authStatus = await messaging().requestPermission();
      const enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL;

      if (enabled) {
        console.log('✅ iOS notification permission granted:', authStatus);
      } else {
        console.log('❌ iOS notification permission denied:', authStatus);
      }
      return enabled;
    } else {
      try {
        const granted = await request(PERMISSIONS.ANDROID.POST_NOTIFICATIONS);
        const isGranted = granted === 'granted';
        console.log(isGranted ? '✅ Android notification permission granted' : '❌ Android notification permission denied');
        return isGranted;
      } catch (err) {
        console.error('❌ Android notification permission error:', err);
        return false;
      }
    }
  } catch (error) {
    console.error('❌ Error checking notification permissions:', error);
    return false;
  }
};

export const registerAppWithFCM = async () => {
  try {
    // Skip Firebase messaging registration on web platform
    if (Platform.OS === 'web') {
      console.log('🌐 [WEB] Skipping Firebase messaging registration on web platform');
      return;
    }

    console.log('🔔 Registering device for remote messages...');
    await messaging().registerDeviceForRemoteMessages();
    console.log('✅ Device registered for remote messages');
  } catch (error) {
    console.error('❌ Error registering device for remote messages:', error);
    throw error;
  }
};

function onNotificationClickActionHandling(clickAction: any, data: any) {
  console.log('Notification click action:', clickAction);
  switch (clickAction) {
    case 'OPEN_CHAT':
      navigationRef.current?.navigate(SCREENS.CHAT_STACK, {
        screen: `${SCREENS.USER_CHAT}`,
        params: {
          chatId: data.chat_id,
        },
      });
      break;
    case 'OPEN_PROFILE':
      // Navigate to profile screen
      break;
    case 'OPEN_NOTIFICATIONS':
      const item = JSON.parse(data.item); // Розпарсити дані item
      navigationRef.current?.navigate(SCREENS.PENDING_ATTENDEES, {eventId: item.event_id, eventName: item.name});
      break;
    case 'OPEN_PAYMENT_SUCCESS':
      // Navigate to payment success page with order_id
      if (data.order_id) {
        navigationRef.current?.navigate(SCREENS.PAYMENT_SUCCESS, { order_id: data.order_id, fromNotifications: true });
      }
      break;
    default:
      break;
  }
}

export function registerListenerWithFCM() {
  // Skip Firebase messaging setup on web platform
  if (Platform.OS === 'web') {
    console.log('🌐 [WEB] Skipping Firebase messaging listener registration on web platform');
    return () => {}; // Return no-op unsubscribe function
  }

  const unsubscribe = messaging().onMessage(async remoteMessage => {
    console.log('onMessage Received:', JSON.stringify(remoteMessage));
    if (remoteMessage?.notification?.title && remoteMessage?.notification?.body) {
      onDisplayNotification(remoteMessage.notification?.title, remoteMessage.notification?.body, remoteMessage?.data);
    }
  });

  // OneSignal notification handling is now set up in App.tsx with observers
  
  messaging().onNotificationOpenedApp(async remoteMessage => {
    console.log('onNotificationOpenedApp Received', JSON.stringify(remoteMessage));
    if (remoteMessage?.data?.clickAction) {
      onNotificationClickActionHandling(remoteMessage.data.clickAction, remoteMessage.data);
    }
  });

  messaging()
    .getInitialNotification()
    .then(remoteMessage => {
      if (remoteMessage) {
        console.log('Notification caused app to open from quit state:', remoteMessage.notification);
        if (remoteMessage?.data?.clickAction) {
          onNotificationClickActionHandling(remoteMessage.data.clickAction, remoteMessage.data);
        }
      }
    });

  return unsubscribe;
}

async function onDisplayNotification(title: any, body: any, data: any) {
  console.log('onDisplayNotification:', JSON.stringify(data));

  // Temporarily using react-native-notifier instead of notifee
  Notifier.showNotification({
    title: title,
    description: body,
    Component: NotifierComponents.Alert,
    componentProps: {
      alertType: 'info',
    },
  });

  // TODO: Re-enable notifee when circular dependency is resolved
  // // Request permissions (required for iOS)
  // await notifee.requestPermission();

  // // Create a channel (required for Android)
  // const channelId = await notifee.createChannel({
  //   id: 'default',
  //   name: 'Default Channel',
  // });

  // // Display a notification
  // await notifee.displayNotification({
  //   title: title,
  //   body: body,
  //   data: data,
  //   android: {
  //     channelId,
  //     pressAction: {
  //       id: 'default',
  //       launchActivity: 'default',
  //     },
  //   },
  // });
}
